import styled from "styled-components";

export const MainWrapper = styled.div`
  width: auto;
  height: 97.55vh;
  padding: 10px;
  /* border: 1px solid red; */
`;

export const BacKNavArea = styled.div`
  width: auto;
  height: 5vh;
  display: flex;
  align-items: center;
`;

export const CenteredObject = styled.div`
  width: auto;
  height: auto;
  height: 88vh;
  /* border: 1px solid black; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CenteredContent = styled.div`
  width: 30%;
  height: 90%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 25px;

  @media (max-width: 728px) {
    gap: 20px;
  }

  @media (max-width: 728px) {
    width: 98%;
  }
`;

export const TextArea = styled.div`
  width: 240px;
  height: auto;
  display: flex;
  /* justify-content: center; */
  align-items: center;

  h2 {
    font-size: 2.2rem;
    line-height: 3rem;
    margin-top: auto;
    margin-bottom: auto;
  }
`;

export const TextPtag = styled.div`
  margin-top: 1px;
  width: 300px;
  height: auto;
  /* border: 1px solid black; */

  p {
    font-size: 14px;
    margin: auto;

    @media (max-width: 728px) {
      font-size: 15px;
    }
  }
`;

export const ButtonArea = styled.div`
  width: auto;
  height: auto;
`;

export const Error = styled.div`
  width: auto;
  height: auto;
  margin-top: -1rem;
  margin-bottom: -1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: red;
    margin: auto;
  }

  span {
    color: green;
    margin: auto;
  }
`;
